import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./pages/AuthContext";

export default function ProtectedRoute() {
  const { user, loading } = useAuth();

  // ⛔ STOP routing until session is checked
  if (loading) {
    return <div>Loading...</div>; // or null
  }

  return user
    ? <Outlet />
    : <Navigate to="/" replace />;
}